import axios from 'axios';

export const CONFIG = {
  USD_RATE: 'USD_RATE',
  PERCENTAGE_COVERED: 'PERCENTAGE_COVERED',
  CEILING_SINGLE: 'CEILING_SINGLE',
  CEILING_MARRIED: 'CEILING_MARRIED',
  CEILING_SINGLE_CHILD: 'CEILING_SINGLE_CHILD',
  CEILING_CHILDREN: 'CEILING_CHILDREN'
};
export const getConfig = async () => {
  const response = await axios.get('/admin-config/configurations');
  // map response data to object
  const config = response.data.reduce((acc, curr) => {
    acc[curr.name] = curr.amount;
    return acc;
  }, {});
  return config;
};

export const addOrUpdateConfig = async (configs) => {
  //check that each configFields key is valid
  if (!Object.keys(configs).every((key) => Object.values(CONFIG).includes(key))) {
    throw new Error('Invalid configuration field');
  }

  //post a request for each configFields key
  await Promise.all(
    Object.keys(configs)
      .filter((configField) => configs[configField] !== undefined && configs[configField] !== null)
      .map(
        async (configField) =>
          await axios.post(`/admin-config/configurations/${configField}`, {
            amount: Number(configs[configField])
          })
      )
  );

  return true;
};

export const resetBalances = async () => {
  await axios.patch('/admin-config/configurations/reset');
  return true;
};
